// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip__vLGObE7N6I{width:180px}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/dashboard/views/queue/components/queues/components/metrics/components/agentPresence/agentPresenceMetric.module.scss"],"names":[],"mappings":"AAEA,qBACE,WAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.tooltip {\n  width: 180px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `tooltip__vLGObE7N6I`
};
export default ___CSS_LOADER_EXPORT___;
